import { render, staticRenderFns } from "./Asistentesxcomando.vue?vue&type=template&id=1a97cc6b&scoped=true"
import script from "./Asistentesxcomando.vue?vue&type=script&lang=js"
export * from "./Asistentesxcomando.vue?vue&type=script&lang=js"
import style0 from "./Asistentesxcomando.vue?vue&type=style&index=0&id=1a97cc6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a97cc6b",
  null
  
)

export default component.exports